// extracted by mini-css-extract-plugin
export default {"summary":"summary_summary__Rg1Bo"};